import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import VouchersCSVUpload from './Components/VouchersCSVUpload'

export default function FaberVouchersUploadPage() {
  const navigate = useNavigate()

  return (
    <PageLayoutV2 header='Vouchers - Faber'>
      <ColorBox>
        <Box>
          <VouchersCSVUpload />
        </Box>
        <Box sx={{ justifyContent: 'flex-end', display: 'flex' }}>
          <Button
            variant='outlined'
            onClick={() => {
              navigate(-1)
            }}
            sx={{ mt: 1, mr: 1 }}
          >
            Back
          </Button>
        </Box>
      </ColorBox>
    </PageLayoutV2>
  )
}
